import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {RecruitsVisibleData} from "../types";
import {getRecruitsVisibleDetail} from "../../service";
import {dateFormat, nounTsf} from "../../units";
import zp from '../../images/zp.png'
import MakePhoneCall from "../../components/makePhoneCall";
import usePhones from "../../routers/usePhones";

function OpportunityDetail() {

    const { id } = useParams<{id:string}>()
    const [info,setInfo] = useState<RecruitsVisibleData>()
    const [cover,setCover] = useState<boolean>(false)
    const phones = usePhones()

    useEffect(() => {
        getRecruitsVisibleDetail({
            recruitId:id
        }).then(res => {
            if(res.code === 1){
                setInfo(res.data)
            }
        })
    },[])

    return <div className="jobs">
        <div className="opportunity-detail">
            <img src={ zp } alt="" style={{ marginBottom:'.3rem' }}/>
            <div className="info">
                <p>岗位编号 { info?.recruitNumber }</p>
                <p>{ info && dateFormat(info.createTime) }发布</p>
            </div>
            <div className="text-box">
                <div className="flex">
                    <p className="title">{ info?.recruitTitle }</p>
                    <p className="salary">{ info?.salary }</p>
                </div>
                <div className="content" dangerouslySetInnerHTML={{ __html: info ? info.recruitDetail : '' }}/>
            </div>
        </div>
        <div className="opportunity-detail-btn" onClick={() => setCover(true)}>申请职位</div>
        <MakePhoneCall show={ cover } telephone={ phones[6] } onClose={() => setCover(false)}/>
    </div>
}

export default OpportunityDetail
